<p-card styleClass="p-card-shadow">

    <ng-template pTemplate="subtitle">
        <div class="flex-container">
            <div class="flex-none">
                <button pButton
                        icon="glyphicon glyphicon-bell"
                        class="p-button-danger bell-button"
                        [pTooltip]="reminder.tooltip"
                        (click)="isReadOnlyUser ? onDetailsClicked.emit(reminder) : menu!.toggle($event)">
                </button>
                <p-tieredMenu *ngIf="!isReadOnlyUser" #menu [popup]="true" appendTo="body" [model]="menuItems"></p-tieredMenu>
            </div>

            <div class="flex-grow">
                <div class="flex-container">
                    <div class="flex-grow">
                        {{reminder.startTime | date: 'MM/dd/yy HH:mm'}}
                        <br>
                        <span *ngIf="reminder.startTime !== reminder.endTime">
                            {{reminder.endTime | date: 'MM/dd/yy HH:mm'}}
                        </span>
                    </div>
                    <div *ngIf="reminder.attachments.length" class="flex-none">
                        <button pButton pRipple (click)="attachmentPanel.show($event)"
                                icon="pi pi-paperclip" class="p-button-rounded p-button-secondary p-button-text">
                        </button>
                        <p-overlayPanel #attachmentPanel appendTo="body">
                            <ng-template pTemplate>
                                <lb-file-attachment-list [fileAttachments]="reminder.attachments"></lb-file-attachment-list>
                            </ng-template>
                        </p-overlayPanel>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="body">
        <div [ngClass]="tagStyleClass" [innerHTML]="reminder.safeHtmlRequest | trustHtml"></div>
    </ng-template>
</p-card>